
import { wgResource, wgResourceType } from "./wgResource.js";
import { wgVertexBuffer } from "./wgVertexBuffer.js";
import { wgVertexDescriptor, VertexType } from "./wgVertexDescriptors.js"
import { wGeoSphereBuilder } from "../wFundament/wGeoSpherebuilder.js"
import { wMath } from "../wFundament/wMath";
import { vec3 } from "gl-matrix";

class wgMeshBuilder extends wgResource {
    constructor(name, context) {
        super(name, context, wgResourceType.wgMeshBuilder);
    }

    buildFullscreenQuad(quadName) {
        let vertexData = new Float32Array(18);

        vertexData[0] = -1.0;
        vertexData[1] = -1.0;
        vertexData[2] = -1.0;

        vertexData[3] = 1.0;
        vertexData[4] = -1.0;
        vertexData[5] = -1.0;

        vertexData[6] = 1.0;
        vertexData[7] = 1.0;
        vertexData[8] = -1.0;

        vertexData[9] = -1.0;
        vertexData[10] = -1.0;
        vertexData[11] = -1.0;

        vertexData[12] = 1.0;
        vertexData[13] = 1.0;
        vertexData[14] = -1.0;

        vertexData[15] = -1.0;
        vertexData[16] = 1.0;
        vertexData[17] = -1.0;

        var vertexBuffer = new wgVertexBuffer(quadName, this.getContext());
        const gl = this.getContext().gl();
        let vertexDescriptor = new wgVertexDescriptor(VertexType.VT_Vertex3, gl);
        vertexBuffer.createVertexBuffer(gl.STATIC_DRAW, vertexDescriptor.vertexLayout_, vertexData.length / 3, vertexDescriptor.getVertexSizeInBytes(), vertexData);
        return vertexBuffer;
    }

    buildBoxWithNormalsMesh(meshName, wBox) {

        let boxTriangles = wBox.getTriangulation()
        let vertexData = new Float32Array(boxTriangles.length * 6);
        let index = 0;

        for (let i = 0; i < boxTriangles.length; i += 3) {
            const v0 = boxTriangles[i];
            const v1 = boxTriangles[i + 1];
            const v2 = boxTriangles[i + 2];

            var n = vec3.create();
            var tmp = vec3.create();
            vec3.cross(tmp, wMath.vec3Sub(v1, v0), wMath.vec3Sub(v2, v0));
            vec3.normalize(n, tmp);

            wMath.addVec3ToFloatArray(v0, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(n, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(v1, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(n, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(v2, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(n, vertexData, index);
            index += 3;
        }

        var vertexBuffer = new wgVertexBuffer(meshName, this.getContext());
        const gl = this.getContext().gl();
        let vertexDescriptor = new wgVertexDescriptor(VertexType.VT_Vertex3Normal3, gl);
        vertexBuffer.createVertexBuffer(gl.STATIC_DRAW, vertexDescriptor.vertexLayout_, vertexData.length / 6, vertexDescriptor.getVertexSizeInBytes(), vertexData);
        return vertexBuffer;
    }

    buildGeoSphereWithNormalsMesh(meshName, center, radius, numSubDivisions = 2) {

        let geoSphereBuilder_ = new wGeoSphereBuilder();
        let triangles = geoSphereBuilder_.buildGeoSphere(numSubDivisions);
        let vertexData = new Float32Array(triangles.length * 6);
        let index = 0;

        for (let i = 0; i < triangles.length; i += 3) {
           
            const v0 = triangles[i];
            const v1 = triangles[i + 1];
            const v2 = triangles[i + 2];

            var n = vec3.create();
            var tmp = vec3.create();
            vec3.cross(tmp, wMath.vec3Sub(v2, v0), wMath.vec3Sub(v1, v0));
            vec3.normalize(n, tmp);

            let v0_ = wMath.vec3Add(wMath.vec3Scale(v0, radius), center);
            let v1_ = wMath.vec3Add(wMath.vec3Scale(v1, radius), center);
            let v2_ = wMath.vec3Add(wMath.vec3Scale(v2, radius), center);

            wMath.addVec3ToFloatArray(v0_, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(n, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(v2_, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(n, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(v1_, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(n, vertexData, index);
            index += 3;
        }

        var vertexBuffer = new wgVertexBuffer(meshName, this.getContext());
        const gl = this.getContext().gl();
        let vertexDescriptor = new wgVertexDescriptor(VertexType.VT_Vertex3Normal3, gl);
        vertexBuffer.createVertexBuffer(gl.STATIC_DRAW, vertexDescriptor.vertexLayout_, vertexData.length / 6, vertexDescriptor.getVertexSizeInBytes(), vertexData);
        return vertexBuffer;
    }

    buildCylinderWithNormalsMesh(meshName, wcyl) {

        let triangles = wcyl.getTriangulation();
        let vertexData = new Float32Array(triangles.length * 6);
        let index = 0;

        for (let i = 0; i < triangles.length; i += 3) {
           
            const v0 = triangles[i];
            const v1 = triangles[i + 1];
            const v2 = triangles[i + 2];

            var n = vec3.create();
            var tmp = vec3.create();
            vec3.cross(tmp, wMath.vec3Sub(v2, v0), wMath.vec3Sub(v1, v0));
            vec3.normalize(n, tmp);

            wMath.addVec3ToFloatArray(v0, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(n, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(v2, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(n, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(v1, vertexData, index);
            index += 3;
            wMath.addVec3ToFloatArray(n, vertexData, index);
            index += 3;
        }

        var vertexBuffer = new wgVertexBuffer(meshName, this.getContext());
        const gl = this.getContext().gl();
        let vertexDescriptor = new wgVertexDescriptor(VertexType.VT_Vertex3Normal3, gl);
        vertexBuffer.createVertexBuffer(gl.STATIC_DRAW, vertexDescriptor.vertexLayout_, vertexData.length / 6, vertexDescriptor.getVertexSizeInBytes(), vertexData);
        return vertexBuffer;

    }
}

export { wgMeshBuilder };